import styled from 'styled-components'

interface StyledTextContainerProps {
  $backgroundColor?: string;
  $textAlign?: string;
}

export const StyledTextContainer = styled.div<StyledTextContainerProps>`
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  background-color: ${({ $backgroundColor }) => $backgroundColor || 'transparent'};
  color: white;
  padding: 20px;
  box-sizing: border-box;

  p {
    margin: 0 0 10px 0;
    line-height: 1.6;
    font-size: 26px;
    text-align: ${({ $textAlign }) => $textAlign || 'center'};
  }

  p:last-child {
    margin-bottom: 0;
  }
`
